export default __webpack_public_path__ + "static/media/close.408d96ce.svg";